export default __webpack_public_path__ + "static/media/Lancheira.3bd61839.jpg";